<template>
  <div :id="componentId" class="sp2-module-2" :style="moduleStyle">
    <div class="sp2-video-wrap" @mouseenter="stopAutoplay" @mouseleave="startAutoplay">
      <div class="sp2-video-image-area" :style="{ backgroundColor: backgroundColor }">
        <img
          v-if="currentItem && currentItem.imageUrl"
          class="sp2-video-image"
          referrerpolicy="no-referrer"
          :src="currentItem.imageUrl"
        />
        <div v-else class="sp2-video-image-placeholder">请配置视频封面图</div>

        <img
          v-if="currentItem && currentItem.jumpUrl"
          class="sp2-play-button"
          src="@/assets/images/play-button.png"
          alt="播放"
          @click="openVideo(currentItem.jumpUrl)"
        />
      </div>

      <div class="sp2-video-sidebar">
        <div class="sp2-sidebar-header">
          <span class="sp2-sidebar-title-text">{{ title || '精彩视频' }}</span>
        </div>
        <div class="sp2-sidebar-list">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="sp2-sidebar-item"
            :class="{ active: currentIndex === index }"
            @click="goToIndex(index)"
          >
            <div class="sp2-sidebar-title">{{ item.title || '未设置标题' }}</div>
          </div>
          <div class="sp2-sidebar-footer">
            <span class="sp2-pagination-text">{{ currentIndex + 1 }} / {{ list.length || 1 }}</span>
            <div class="sp2-arrow-group">
              <span class="sp2-arrow sp2-arrow-left" :class="{ disabled: !canGoPrev }" @click="goPrev">
                <i class="el-icon-arrow-left" />
              </span>
              <span class="sp2-arrow sp2-arrow-right" :class="{ disabled: !canGoNext }" @click="goNext">
                <i class="el-icon-arrow-right" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SpTwoModule2',
  props: {
    componentId: {
      type: String,
      default: 'sp_two_module_2'
    }
  },
  data() {
    return {
      title: '精彩视频',
      backgroundColor: '#fff',
      list: [
        {
          imageUrl: '',
          jumpUrl: '',
          title: '第七届中国品牌发展论坛系列活动现场花絮1！'
        },
        {
          imageUrl: '',
          jumpUrl: '',
          title: '第七届中国品牌发展论坛系列活动现场花絮2！'
        },
        {
          imageUrl: '',
          jumpUrl: '',
          title: '第七届中国品牌发展论坛系列活动现场花絮3！'
        },
        {
          imageUrl: '',
          jumpUrl: '',
          title: '第七届中国品牌发展论坛系列活动现场花絮4！'
        }
      ],
      currentIndex: 0,
      timer: null
    };
  },
  computed: {
    currentItem() {
      return this.list[this.currentIndex] || null;
    },
    hasMultiple() {
      return this.list.length > 1;
    },
    canGoPrev() {
      return this.currentIndex > 0;
    },
    canGoNext() {
      return this.currentIndex < this.list.length - 1;
    },
    moduleStyle() {
      return {
        backgroundColor: this.backgroundColor
      };
    }
  },
  mounted() {
    this.startAutoplay();
  },
  beforeDestroy() {
    this.stopAutoplay();
  },
  methods: {
    startAutoplay() {
      if (!this.hasMultiple) return;
      this.stopAutoplay();
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.list.length;
      }, 4000);
    },
    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    goToIndex(index) {
      if (index < 0 || index >= this.list.length) return;
      this.currentIndex = index;
      this.stopAutoplay();
      this.startAutoplay();
    },
    goPrev() {
      if (!this.canGoPrev) return;
      this.currentIndex--;
      this.stopAutoplay();
      this.startAutoplay();
    },
    goNext() {
      if (!this.canGoNext) return;
      this.currentIndex++;
      this.stopAutoplay();
      this.startAutoplay();
    },
    openVideo(url) {
      if (!url) return;
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped>
.sp2-module-2 {
  position: relative;
  width: 2000px;
  min-width: 2000px;
  max-width: 2000px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.sp2-video-wrap {
  display: flex;
  width: 1399px;
  height: 620px;
  margin: 0 auto;
  border-radius: 12px;
  overflow: hidden;
}

.sp2-video-image-area {
  position: relative;
  width: 1039px;
  height: 620px;
  flex-shrink: 0;
  overflow: hidden;
}

.sp2-video-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp2-video-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
  background: #e0e0e0;
}

.sp2-play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 131px;
  height: 131px;
  cursor: pointer;
  z-index: 2;
  transition: transform 0.3s ease;
  object-fit: contain;
}

.sp2-play-button:hover {
  transform: translate(-50%, -50%) scale(1.08);
}

.sp2-video-sidebar {
  width: 360px;
  height: 620px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
  box-sizing: border-box;
}

.sp2-sidebar-header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 88px;
  background: linear-gradient( 90deg, #1F48BC 0%, #6592E3 100%);
  flex-shrink: 0;
}

.sp2-sidebar-title-text {
  display: block;
  width: 144px;
  height: 45px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 34px;
  color: #FFFFFF;
  letter-spacing: 2px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  line-height: 45px;
}

.sp2-sidebar-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  overflow-y: auto;
}

.sp2-sidebar-item {
  display: flex;
  align-items: center;
  width: 360px;
  height: 60px;
  padding: 0 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.sp2-sidebar-item:hover {
  background: #e6f2ff;
  height: 88px;
}

.sp2-sidebar-item.active {
  background:linear-gradient( 90deg, #D3DEF1 0%, #9FB6E0 100%);
  height: 88px;
}

.sp2-sidebar-title {
  width: 300px;
  height: 60px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 20px;
  color: #000000;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.sp2-sidebar-item.active .sp2-sidebar-title {
  color: #000000;
  font-weight: 600;
}

.sp2-sidebar-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 300px;
  height: 56px;
  padding: 0;
  background: transparent;
}

.sp2-pagination-text {
  font-size: 14px;
  color: #606266;
  margin-right: 16px;
}

.sp2-arrow-group {
  display: flex;
  gap: 10px;
}

.sp2-arrow {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e6f2ff;
  color: #2b6cb0;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sp2-arrow:hover:not(.disabled) {
  background: #2b6cb0;
  color: #fff;
}

.sp2-arrow.disabled {
  background: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}
</style>
